import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import {
  Input,
  Table,
  Tag,
  Button,
  message,
  Form,
  Row,
  DatePicker,
  Col,
  Modal,
  Card,
  Radio,
} from "antd";
import Service from "../../../service";
import moment from "moment";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { showAuthLoader, hideAuthLoader } from "../../../appRedux/actions/Auth";
import { getResource } from "../../../util/getResourcePermission";
import config from "../../../permission/config.json"
import AddWfhRequestModal from "./AddWfhRequest";
import { ArrowLeftOutlined, PlusOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { capitalizeFirst } from "../../../util/YearOptions";
import NodataFoundIcon from "../../../assets/images/NodataFoundIcon";
import ApprovalStatusCell from "../../Approvals/ApprovalStatusCell";
import useCompanyDateFormat from "../../../hooks/useCompanyDateFormat";
import { TABLE_PAGINATION, DEFAULT_PAGE_SIZE } from "../../../constants/tablePagination";
import GuidedTour, { hasTourFlag } from "../../common/GuidedTour/GuidedTour";
const Search = Input.Search;

const TOUR_STORAGE_KEY = "tour_seen_wfh_listing";
const TOUR_HINT_STORAGE_KEY = "tour_hint_dismissed_wfh_listing";
// Steps whose target field lives inside the Add WFH Application modal - the
// tour opens that real modal itself when it reaches one of these.
const MODAL_STEP_IDS = ["wfh-from-date", "wfh-weekoff", "wfh-days", "wfh-reason", "wfh-save-btn"];

const Wfhlisting = (props) => {
  const companySlug = localStorage.getItem("companyDomain")
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [IsModalView, setIsModalView] = useState(false);
  const [seachEnabled, setSearchEnabled] = useState(false);
  const [val, setVal] = useState("All");
  let [filterData, setFilterData] = useState([]);
  const searchRef = useRef();
  const [empData, setEmpData] = useState([]);
  const [employeeData, setEmployeeData] = useState({})
  const [isWFHModalOpen, setisWFHModalOpen] = useState(false);
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [isTourHintOpen, setIsTourHintOpen] = useState(false);

  // First-time visitors get a "click here" nudge pointing at the guide
  // trigger. It stays up until dismissed, which marks it done via its own
  // storage key so it never comes back.
  useEffect(() => {
    if (hasTourFlag(TOUR_STORAGE_KEY) || hasTourFlag(TOUR_HINT_STORAGE_KEY)) return;
    const showTimer = setTimeout(() => setIsTourHintOpen(true), 600);
    return () => clearTimeout(showTimer);
  }, []);

  // Once the tour walks past the "+ WFH Application" button, it opens the
  // real Add WFH Application modal so the remaining steps can point at its
  // actual fields - and closes it again once the tour leaves those steps.
  const handleTourStepChange = useCallback((step) => {
    setisWFHModalOpen(Boolean(step && MODAL_STEP_IDS.includes(step.id)));
  }, []);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: DEFAULT_PAGE_SIZE,
  });
  const dispatch = useDispatch();
  const dateFormat = useCompanyDateFormat();
  const [form] = Form.useForm();
  const formValues = Form.useWatch([], form);
  const hasAnyValue = formValues
    ? Object.values(formValues).some((v) => v !== undefined && v !== null && v !== "")
    : false;
  let { authUser } = useSelector(({ auth }) => auth);

  useEffect(() => {
    getEmployeesLeaveList();
  }, [filterData, searchText, pagination.current, pagination.pageSize]);

  const getEmployeesLeaveList = useCallback(async () => {
    try {
      dispatch(showAuthLoader());
      const reqBody = {
        emp_code: authUser?.emp_code,
        pageNum: pagination.current,
        pageLimit: pagination.pageSize,
        // application_to_date: filterData?.application_to_date
        //   ? moment(filterData?.application_to_date).format("YYYY-MM-DD")
        //   : moment().format("YYYY-MM-DD"),
        // to_date: moment(filterData?.leave_from_date).format("YYYY-MM-DD")
        //   ? moment()
        //   : filterData?.leave_to_date,
        status: "All",
      };
      if (searchText && searchText !== "") {
        reqBody.search = searchText;
        setSearchEnabled(true);
      }
      if (filterData) {
        if (filterData?.status) {
          reqBody.status = filterData.status;
        }
        if (filterData?.application_from_date) {
          reqBody.application_from_date = moment(
            filterData.application_from_date
          ).format("YYYY-MM-DD");
        }
        // if (filterData?.application_to_date) {
        //   reqBody.application_to_date = moment(
        //     filterData.application_to_date
        //   ).format("YYYY-MM-DD");
        // }
        if (filterData?.from_date) {
          reqBody.from_date = moment(filterData.from_date).format("YYYY-MM-DD");
        }
        if (filterData?.to_date) {
          reqBody.to_date = moment(filterData.to_date).format("YYYY-MM-DD");
        }
      }

      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.wfhlisting,
        body: reqBody,
      });

      dispatch(hideAuthLoader());
      if (response?.data?.data?.length > 0) {
        if (filterData?.isActive == true) {
          setPagination({
            ...pagination,
            total: response.data.metaData.totalFilteredCount,
            deactivetotal: response.data.metaData.totaldUsers,
          });
        } else {
          setPagination({
            ...pagination,
            total: response.data.metaData.totalFilteredCount,
            // deactivetotal: response.data.metaData.totaldsUsers,
          });
        }

        const employee = response.data.data;
        employee?.map((val, index) => (val["key"] = val?._id));
        setEmpData([]);
        setEmpData(employee);
      } else {
        setPagination({
          ...pagination,
          total: 0,
        });
        setEmpData([]);
        // message.error(response.data.message);
      }
    } catch (error) {
      dispatch(hideAuthLoader());
      console.log(error);
    }
  }, [filterData, searchText, pagination.current, pagination.pageSize]);

  const filterEmp = async (values) => {
    if (
      (values.application_from_date &&
        values.application_to_date == undefined) ||
      "" ||
      null
    ) {
      message.error("Please select Application To date");
      return;
    }
    if (
      (values.application_to_date &&
        values.application_from_date == undefined) ||
      "" ||
      null
    ) {
      message.error("Please select Application from date");
      return;
    }

    if ((values.from_date && values.to_date == undefined) || "" || null) {
      message.error("Please select WFH to date");
      return;
    }
    if ((values.to_date && values.from_date == undefined) || "" || null) {
      message.error("Please select WFH from date");
      return;
    }
    setFilterData(values);
    setIsModalView(!IsModalView);
  };

  const getFooterDetails = () => {
    return (
      <label>
        Total Records Count is {pagination.total > 0 ? pagination.total : 0}
      </label>
    );
  };

  const handleTableChange = (page, filters, sorter) => {
    setPagination({ ...pagination, ...page });
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const openEventModalView = () => {
    // setEvent_record(record);
    setIsModalView(true);
  };
  const closeEventModalView = () => {
    // setEvent_record(record);
    form.resetFields();
    setIsModalView(!IsModalView);
    // setFilterData([]);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  };

  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 16,
        offset: 8,
      },
    },
  };

  const onSearch = (value) => {
    setSearchText(value);
    setPagination({ ...pagination, current: 1 });
  };

  const resetSearchFilter = (e) => {
    const keyCode = e && e.keyCode ? e.keyCode : e;
    switch (keyCode) {
      case 8:
        if (searchRef.current.state?.value?.length <= 1 && seachEnabled) {
          searchRef.current.state.value = "";
          setSearchText("");
          setSearchEnabled(false);
        }
        break;
      case 46:
        if (searchRef.current.state?.value?.length <= 1 && seachEnabled) {
          searchRef.current.state.value = "";
          setSearchText("");
          setSearchEnabled(false);
        }
        break;
      default:
        break;
    }
  };

  const columns = [
    {
      title: "Application Date",
      dataIndex: "application_date",
      key: "application_date",
      render: (text, record, index) => {
        const event_name = record.application_date
          ? moment(record.application_date).format(dateFormat)
          : "-";
        return (
          // <Link type="button" to={`/event/event-view/${record._id}`}>

          <span style={{ textTransform: "capitalize" }}>{event_name}</span>
          // </Link>
        );
      },
    },
    {
      title: val != "Rejected" ? "Approval Date" : "Rejected Date",
      dataIndex: "leave_approval_date",
      key: "leave_approval_date",
      render: (text, record, index) => {
        const adate = record?.WFH_approval_date
          ? moment(record?.WFH_approval_date).format(dateFormat)
          : "-";
        const adate2 = record?.WFH_rejected_date
          ? moment(record?.WFH_rejected_date).format(dateFormat)
          : "-";
        return <span>{val != "Rejected" ? adate : adate2}</span>;
      },
    },

    {
      title: "Manager",
      dataIndex: "reporting_manager",
      key: "reporting_manager",
      render: (text, record, index) => {
        const adate = record?.reporting_manager;

        return <span>{capitalizeFirst(adate)}</span>;
      },
    },
    {
      title: "From Date",
      dataIndex: "from_date",
      key: "from_date",
      render: (text, record, index) => {
        let adate = moment(record?.from_date).format(dateFormat);
        return <span>{adate}</span>;
      },
    },
    {
      title: "No of Days",
      dataIndex: "no_of_days",
      key: "no_of_days",
      render: (text, record, index) => {
        let adate = record?.no_of_days;

        return <span>{adate}</span>;
      },
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      render: (text, record, index) => {
        let adate = capitalizeFirst(record?.reason);
        return (
          <>
            <span>{adate?.substring(0, 50)}</span>
            <br />
            <span>{adate?.substring(50)}</span>
          </>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "leave_status",
      render: (text, record, index) => {
        if (record?.approval_progress) {
          return <ApprovalStatusCell progress={record.approval_progress} />;
        }

        const position = record?.status;

        const color =
          record?.status == "Pending"
            ? "orange"
            : record?.status == "Accepted"
              ? "green"
              : "red";

        return position ? <Tag color={color}>{capitalizeFirst(position)}</Tag> : null;
      },
    },
  ];

  const fetchEmployeeDetails = async () => {
    try {
      dispatch(showAuthLoader());
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: Service.empById + `/${authUser._id}`
      });
      if (response?.data && response.data.status === 200) {
        const empData = response?.data?.data

        setEmployeeData(empData)
      } else {
        message.error(response.data.message)
      }
      dispatch(hideAuthLoader());
    } catch (error) {
      dispatch(hideAuthLoader());
      console.log(error);
    }
  };
  useEffect(() => { fetchEmployeeDetails() }, [])

  const canCreate = getResource(config.RESOURCES.WHF_APPLICATIONS, ["create"]);

  const tourSteps = useMemo(() => {
    const steps = [
      {
        id: "wfhl-table",
        target: '[data-tour="wfhl-table"]',
        title: "Your WFH requests",
        content: "See your past work-from-home requests here, along with their approval status.",
      },
    ];
    if (canCreate) {
      steps.push(
        {
          id: "wfhl-add-btn",
          target: '[data-tour="wfhl-add-btn"]',
          title: "Apply for WFH",
          content: "Click here to apply - it opens a short form.",
        },
        {
          id: "wfh-from-date",
          target: '[data-tour="wfh-from-date"]',
          title: "First day of WFH",
          content: "Pick the start date. A note above may show any WFH limit rule that applies to you.",
        },
        {
          id: "wfh-weekoff",
          target: '[data-tour="wfh-weekoff"]',
          title: "Weekends in between",
          content: "Choose Yes if weekoff days inside your WFH range should also count as WFH days, No if they shouldn't.",
        },
        {
          id: "wfh-days",
          target: '[data-tour="wfh-days"]',
          title: "How many days",
          content:
            "Enter in 0.5-day steps (0.5, 1, 1.5...). To Date fills itself in from this. If it works out to a half day, a 'Date For Half Day' and 'WFH type' field will also appear here.",
        },
        {
          id: "wfh-reason",
          target: '[data-tour="wfh-reason"]',
          title: "Say why",
          content: "This is required before you can save.",
        },
        {
          id: "wfh-save-btn",
          target: '[data-tour="wfh-save-btn"]',
          title: "Submit for approval",
          content: "Save sends this WFH request to your Reporting Manager.",
        }
      );
    }
    return steps;
  }, [canCreate]);

  const hintSteps = useMemo(
    () => [
      {
        target: '[data-tour="wfhl-guide-icon"]',
        shape: "circle",
        title: "New here?",
        content: "Click this icon anytime for a quick, step-by-step guide to this screen.",
      },
    ],
    []
  );

  return (
    <>

      <Card className="employee-card" >
        <div className="inout-header text-left">
          <h2>
            Work From Home Applications{" "}
            <QuestionCircleOutlined
              data-tour="wfhl-guide-icon"
              className="guide-title-icon"
              role="button"
              tabIndex={0}
              onClick={() => {
                setIsTourHintOpen(false);
                setIsTourOpen(true);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  setIsTourHintOpen(false);
                  setIsTourOpen(true);
                }
              }}
              title="Click for a step-by-step guide"
            />
          </h2>
          <div className="header-btns">
            {
              canCreate && (

                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => setisWFHModalOpen(true)}
                  data-tour="wfhl-add-btn"
                >
                  WFH Application
                </Button>
              )
            }
            <Link to={`/${companySlug}/leave-application`}>
              <Button type="primary" icon={<ArrowLeftOutlined />} style={{ marginLeft: "5px" }}>
                Back
              </Button></Link>

          </div>
        </div>
        <Card className="main-content-wrapper" >
          <div className="search-wrapper">
            <Search
              ref={searchRef}
              placeholder="Search..."
              onSearch={onSearch}
              onKeyUp={resetSearchFilter}
              style={{ width: 200 }}
              className="mr2"
            />
            <div className="filter-btns-wrapper">

              <Button
                onClick={() => openEventModalView()}
                className="mr2  filter-btn"
                type="primary"
              >
                Filter
              </Button>
              <Button
                onClick={() => {
                  form.resetFields();
                  setFilterData([]);
                  setVal("All");
                }}
                className="mr2 ant-delete"
                disabled={filterData.length != 0 ? false : true}
              >
                Reset
              </Button>
            </div>
          </div>

          <Modal
            title="Filter"
            width={800}
            visible={IsModalView}
            okText="Update"
            footer={[<>
              <Button

                className="ant-delete"
                onClick={() => {
                  setIsModalView(false)
                }}
                style={{ marginLeft: "10px" }}
              >
                Cancel
              </Button>
              <Button

                className="ant-delete"
                onClick={() => {
                  form.resetFields();
                  setFilterData([]);
                }}
                style={{ marginLeft: "10px" }}
                disabled={!hasAnyValue}

              >
                Reset
              </Button>
              <Button type="primary" onClick={() => form.submit()} htmlType="submit">
                Apply
              </Button>

            </>]}
            onCancel={closeEventModalView}
          >
            <Form form={form} layout="vertical" className="modal-form-col" onFinish={filterEmp}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12}>

                  <Form.Item
                    label="Application From Date "
                    name="application_from_date"
                    className="search-row"
                    onChange={
                      form.getFieldValue("application_to_date") == undefined ||
                        "" ||
                        null
                        ? form.setFieldsValue({
                          application_to_date:
                            filterData?.application_from_date,
                        })
                        : ""
                    }
                  >
                    <DatePicker
                      format={"DD-MM-YYYY"}
                      className="fulldate-width"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>

                  <Form.Item
                    label="WFH From Date "
                    name="from_date"
                    className="search-row"
                    onChange={
                      form.getFieldValue("leave_to_date") == undefined ||
                        "" ||
                        null
                        ? form.setFieldsValue({
                          leave_to_date: filterData?.leave_from_date,
                        })
                        : ""
                    }
                  >
                    <DatePicker
                      format={"DD-MM-YYYY"}
                      className="fulldate-width"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Application To Date "
                    name="application_to_date"
                    className="search-row"
                  >
                    <DatePicker
                      format={"DD-MM-YYYY"}
                      className="fulldate-width"
                      disabledDate={(value) => {
                        return (
                          value < form.getFieldValue("application_from_date")
                        );
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="WFH To Date "
                    name="to_date"
                    className="search-row"
                  >
                    <DatePicker
                      format={"DD-MM-YYYY"}
                      className="fulldate-width"
                      disabledDate={(value) => {
                        return value < form.getFieldValue("from_date");
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    className="radio_group leave-radio"
                    name="status"
                    initialValue="All"
                  >
                    <Radio.Group
                      name="radiogroup"
                      className="start-enddate"
                      onChange={(e) => {
                        setVal(e.target.value);
                      }}
                    >
                      <Radio value="All">All</Radio>
                      <Radio value="Pending">Pending</Radio>
                      <Radio value="Accepted">Approved</Radio>
                      <Radio value="Rejected">Rejected</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>


            </Form>
          </Modal>
          <div className='main-table-wrapper' data-tour="wfhl-table">

            <Table
              columns={columns}
              pagination={{
                ...TABLE_PAGINATION,
                ...pagination,
              }}
              // rowSelection={rowSelection}
              footer={getFooterDetails}
              onChange={handleTableChange}
              dataSource={empData}
                locale={ { emptyText: <NodataFoundIcon/> } }
            />

          </div>
        </Card>
      </Card>

      <AddWfhRequestModal
        show={isWFHModalOpen}
        onClose={() => setisWFHModalOpen(false)}
        onSuccess={() => {
          setisWFHModalOpen(false);
          getEmployeesLeaveList();
        }}
      />

      {isTourOpen && (
        <GuidedTour
          steps={tourSteps}
          onClose={() => setIsTourOpen(false)}
          onStepChange={handleTourStepChange}
          storageKey={TOUR_STORAGE_KEY}
        />
      )}

      {!isTourOpen && isTourHintOpen && (
        <GuidedTour
          steps={hintSteps}
          onClose={() => setIsTourHintOpen(false)}
          storageKey={TOUR_HINT_STORAGE_KEY}
        />
      )}
    </>
  );
};

export default Wfhlisting;
